module.exports = __webpack_public_path__ + "static/img/moment5.d8c4fab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/moment5.png
// module id = rte8
// module chunks = 1